import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { CustomLoader } from 'components/CustomLoader/CustomLoader';
import InactivityTimer from 'components/InactivityTimer/InactivityTimer';
import store from 'store';
import { productsApi } from 'store/slices/products-api';
import { profileApi } from 'store/slices/profile-api';
import { setTheme } from 'store/slices/theme-slice';
import { preloadQueries } from 'utils/preloading';
import { getSignupStatus } from 'utils/signup-status';
import {
  decodeToken,
  getTokenStatus,
  loadTokenFromStorage,
  setToken,
} from 'utils/token';
import { SideNav } from '../../components/SideNav/SideNav';
import { hideZendesk } from 'utils/zendesk';
export const Route = createFileRoute('/_authenticated')({
  component: PrivateLayout,
  beforeLoad: async ({ location }) => {
    store.dispatch(setTheme('dark'));
    const token = loadTokenFromStorage();
    const tokenStatus = getTokenStatus(decodeToken(token));

    if (tokenStatus.status == 'authenticated') {
      setToken(token!);
    } else if (tokenStatus.status == 'unauthenticated') {
      throw redirect({
        to: '/auth/login',
        search: {
          redirect: location.href,
        },
      });
    } else if (tokenStatus.status == 'needs-2fa') {
      setToken(token!);
      throw redirect({
        to: '/auth/login/2fa',
        search: {
          redirect: location.href,
        },
      });
    }

    const { active, defaultSignupPage } = await getSignupStatus();
    if (!active) {
      throw redirect({
        to: defaultSignupPage!,
      });
    }
  },
  pendingComponent: () => <CustomLoader page />,
  loader: async () => {
    await preloadQueries(
      profileApi.endpoints.getProfile.initiate(),
      profileApi.endpoints.getLoginMethods.initiate(),
      productsApi.endpoints.getAvailableProducts.initiate(),
    );
  },
});

export default function PrivateLayout() {
  return (
    <>
      <InactivityTimer />
      <SideNav>
        <Outlet />
      </SideNav>
    </>
  );
}
